import { useState } from 'react'
import { LuEye, LuEyeOff } from 'react-icons/lu'
import './_Input.scss'

const Input = ({
	value,
	onChange,
	onKeyDown,
	id,
	type = 'text',
	placeholder,
	leftIcon,
}: {
	value: string
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
	id?: string
	type?: string
	placeholder: string
	leftIcon?: React.ReactNode
}) => {
	const [showPassword, setShowPassword] = useState(false)
	const isPasswordField = type === 'password'
	const inputType = isPasswordField && showPassword ? 'text' : type

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword)
	}

	if (leftIcon || isPasswordField) {
		return (
			<div className="relative">
				{leftIcon && (
					<div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
						{leftIcon}
					</div>
				)}
				<input
					placeholder={placeholder}
					onChange={onChange}
					onKeyDown={onKeyDown}
					value={value}
					type={inputType}
					id={id}
					className={`text-input border border-gray-300 focus:border-gray-500 block w-full p-[8px] outline-none rounded-md shadow-sm ${
						leftIcon ? 'pl-10' : ''
					} ${isPasswordField ? 'pr-10' : ''}`}
				/>
				{isPasswordField && (
					<button
						type="button"
						onClick={togglePasswordVisibility}
						className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
					>
						{showPassword ? LuEyeOff({ size: 18 }) : LuEye({ size: 18 })}
					</button>
				)}
			</div>
		)
	}

	return (
		<input
			placeholder={placeholder}
			onChange={onChange}
			onKeyDown={onKeyDown}
			value={value}
			type={type}
			id={id}
			className="text-input border border-gray-300 focus:border-gray-500 block w-full p-[8px] outline-none rounded-md shadow-sm"
		/>
	)
}

export default Input
